/* eslint-disable @typescript-eslint/naming-convention */
export const BLACKLISTED_COMPONENTS_ON_THEME_PREVIEW = [
    'RappiderModalComponent',
    'RappiderLottiePlayerComponent',
    'RappiderMediaPlayerComponent',
    'RappiderAssetPickerComponent',
    'RappiderStripeComponent'
];
